"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const stimulus_1 = require("@hotwired/stimulus");
class default_1 extends stimulus_1.Controller {
    constructor() {
        super(...arguments);
        this.show = () => __awaiter(this, void 0, void 0, function* () {
            console.log("dialog:show-start");
            this.element.removeAttribute("hidden");
            console.log("dialog:show-end");
            document.body.dataset.dialog = "visible";
            // When the dialog is shown we return a promise
            // We keep a local copy of the resolve and reject callbacks so they can be called locally
            return new Promise((resolve, reject) => {
                this._resolve = resolve;
                this._reject = reject;
            });
        });
    }
    connect() { }
    resolve(event) {
        // event.preventDefault()
        // const target = event.target as HTMLElement;
        // target.dispatchEvent(new Event('location-menu:select', {
        //     bubbles: true
        // }));
        // console.log('dialog:resolve', target, target.dataset.locationId, target.innerText)
        // // this._resolve?.({
        // //     id: target.dataset.locationId || '',
        // //     label: target.innerText
        // // });
        // this.close()
    }
    close() {
        console.log("dialog:close-start");
        this.element.setAttribute("hidden", "true");
        // this._resolve?.(undefined);
        console.log("dialog:close-end");
        document.body.dataset.dialog = "hidden";
    }
}
exports.default = default_1;
